'use client'

import type { ReactNode } from 'react'

import { Skeleton } from '@morpho-org/ui-v6/server'

import { VaultV2RowList } from '../../../components/VaultV2RowList'
import { CAP_CHANGE_NOTICE_BELOW_TARGET_NOTE, CAP_CHANGE_NOTICE_ROW_COPY } from '../CapChangeNotice'
import { VAULT_EXPOSURE_TIMELOCKS_DESCRIPTION } from '../utils'

/** The copy, hidden under a skeleton, so it wraps like the loaded text at every width. */
const SkeletonText = ({ children }: { children: ReactNode }) => {
  return (
    <span className="text-2xs relative">
      <span className="invisible">{children}</span>
      <Skeleton className="absolute inset-0" />
    </span>
  )
}

const VaultV2TimelocksLoading = () => {
  return (
    <div aria-hidden className="flex flex-col">
      <div className="gap-sm flex flex-col">
        <SkeletonText>{VAULT_EXPOSURE_TIMELOCKS_DESCRIPTION}</SkeletonText>
        <VaultV2RowList>
          {Object.entries(CAP_CHANGE_NOTICE_ROW_COPY).map(([functionName, { description }]) => (
            <div
              key={functionName}
              className="gap-md border-border py-xs flex min-h-14 items-start justify-between border-b-[0.5px] last:border-b-0"
            >
              <div className="gap-2xs flex min-w-0 flex-col">
                <Skeleton className="h-md w-[160px]" />
                <SkeletonText>{description}</SkeletonText>
              </div>
              {/* Most visited vaults sit below the recommended timelock, so their rows carry its note. */}
              <div className="gap-2xs flex shrink-0 flex-col items-end">
                <Skeleton className="h-md w-[64px]" />
                <SkeletonText>{CAP_CHANGE_NOTICE_BELOW_TARGET_NOTE}</SkeletonText>
              </div>
            </div>
          ))}
        </VaultV2RowList>
      </div>

      <div className="mt-sm flex justify-center">
        <Skeleton className="h-[28px] w-[120px]" />
      </div>
    </div>
  )
}

export default VaultV2TimelocksLoading
